module.exports = __webpack_public_path__ + "resources/img/bg_cover_intro_v2.b085823ac656e7b8ebe6805163fc395b.png";